// automatically generated by yarn -config-overrides.js, do not modify

import petition from '/var/www/proca/src/components/Petition.js'

import share from '/var/www/proca/src/components/Share.js'
let steps={};
steps['petition']=petition;
steps['share']=share;
export {steps as allSteps}
export {steps}
